import { USER_EMAIL } from '@/_shared/constants/mock';
import { UserAuthErrorType, UserWarningType } from '@/swagger/constants/slash-enums';
import {
  OrganizationConfig,
  Organizations,
  ProviderIntegrationStatus,
  Providers,
  UserProfile,
  UserStatusEnum,
} from '../types';

export const MOCK_RESPONSE_GET_USER_PROFILE: UserProfile = {
  firstName: 'John',
  lastName: 'Doe',
  email: USER_EMAIL,
  idp: '',
  status: UserStatusEnum.Enabled,
  language: 'it',
  roles: ['HR Manager'],
  claims: ['Organization.Read', 'People.Read', 'Dashboard.Read'],
};

export const MOCK_RESPONSE_GET_ORGANIZATIONS: Organizations = {
  data: [
    {
      organizationId: 'b075cb4c-d2e0-4146-9bb4-f8bdb7e79de7',
      name: 'altermAInd',
      vatNumber: '12345678901',
      userId: '6926e32a7a08bb4a3867cadd',
    },
  ],
  totalItems: 1,
};

export const MOCK_RESPONSE_GET_ORGANIZATION_CONFIG: OrganizationConfig = {
  hasViewConfig: false,
  email: 'email@prova.it',
};

export const MOCK_RESPONSE_PUT_SET_ORGANIZATION = {
  status: 'ok',
};

export const MOCK_RESPONSE_GET_PROVIDERS: {
  data: Providers;
  integrationStatuses: ProviderIntegrationStatus[];
} = {
  data: [
    {
      key: 'azurerm',
      value: 'Azure',
    },
    {
      key: 'm365',
      value: 'Microsoft 365',
    },
  ],
  integrationStatuses: [
    {
      key: 'azurerm',
      enabled: false,
      integrationId: '6dd6a9bc-7e4d-4c96-b816-cf93e736a359',
      name: 'Cloud 1',
      status: 'FAILED',
      failureReason: null,
      isDataReliable: true,
      totalActiveInstances: 100,
    },
    {
      key: 'azurerm',
      enabled: false,
      integrationId: '83288b25-e244-4e53-832a-fcef9f9ef1c3',
      name: 'Cloud 2',
      status: 'FAILED',
      failureReason: null,
      isDataReliable: true,
      totalActiveInstances: 56,
    },
    {
      key: 'azurerm',
      enabled: true,
      integrationId: 'c13d7218-5250-4bf5-bcf2-1552df9c6c8a',
      name: 'Cloud 3',
      status: 'ACTIVE',
      failureReason: null,
      isDataReliable: false,
      totalActiveInstances: 78,
    },
  ],
};

export const MOCK_RESPONSE_GET_USER_WARNINGS: {
  type?: `${UserWarningType}`;
  metadata?: { [key: string]: string | boolean };
}[] = [
  {
    type: UserWarningType.SUBSCRIPTION_BETA_EXPIRING,
    metadata: {
      expiringDate: '2026-05-30T00:00:00Z',
      showDialog: true,
      level: 'info',
    },
  },
];

export const MOCK_ERROR_GET_USER_AUTHORIZE = {
  type: UserAuthErrorType.SUBSCRIPTION_EXPIRED,
  message: 'Your beta subscription has expired.',
  status: 403,
};

export const MOCK_RESPONSE_PUT_SET_LANGUAGE = {
  status: 'ok',
};
